module.exports = __webpack_public_path__ + "img/indoor.4c0e1451.svg";